var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_has.js
// module id = 99
// module chunks = 168707334958949